import {
  BatchSpanProcessor,
  WebTracerProvider,
} from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { Resource } from "@opentelemetry/resources";
// import { SEMRESATTRS_SERVICE_NAME } from "@opentelemetry/semantic-conventions";
export function startTelemery(token) {
  const collectorOptions = {
    url: "https://gw-apm.agi7.ai/v1/traces", // url is optional and can be omitted - default is http://localhost:4318/v1/traces
    headers: { Authorization: `Bearer ${token}` }, // an optional object containing custom headers to be sent with each request
    concurrencyLimit: 10, // an optional limit on pending requests
  };
  let env;
  //@ts-ignore
  const envStr = window.agi7Info || "";
  if (envStr.indexOf("test") !== -1) {
    env = "test";
  } else if (envStr.indexOf("dev") !== -1) {
    env = "dev";
  } else if (process.env?.NODE_ENV === "production") {
    env = "prod";
  } else {
    env = "dev";
  }
  const provider = new WebTracerProvider({
    resource: new Resource({
      "service.name": "web",
      env,
    }),
  });
  const exporter = new OTLPTraceExporter(collectorOptions);
  provider.addSpanProcessor(
    new BatchSpanProcessor(exporter, {
      // The maximum queue size. After the size is reached spans are dropped.
      maxQueueSize: 100,
      // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
      maxExportBatchSize: 10,
      // The interval between two consecutive exports
      scheduledDelayMillis: 500,
      // How long the export can run before it is cancelled
      exportTimeoutMillis: 30000,
    }),
  );
  provider.register();
  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      // new XMLHttpRequestInstrumentation({
      //   ignoreUrls: [/maps.googleapis.com/],
      // }),
    ],
  });
}
